import React from "react";
import { useParams } from "react-router-dom";

import { useGetAuxiliaryComponent, useGetStepsByComponent } from "@hooks";
import {
  AuxiliaryComponentDetails,
  CommentView,
  ImageGrid,
  Loading,
} from "@components";
import { Layout } from "./PageLayouts";
import { ModuleImage } from "@constants";
import { convertDateToTimestamp } from "@utils";

export function AuxiliaryComponentPage() {
  const { auxiliaryComponentSerial } = useParams();
  const [auxComponentData, { update }] = useGetAuxiliaryComponent(
    auxiliaryComponentSerial ?? "",
  );
  const { documents: maybeSteps } = useGetStepsByComponent(
    auxiliaryComponentSerial ?? "",
  );
  const imageList = React.useMemo(
    () =>
      maybeSteps
        ? (maybeSteps
            .filter((step) => step.image && step.image.src && step.image.alt)
            .map((step) => ({
              timestamp: convertDateToTimestamp(step.timestamp),
              // We know this is a string because we filtered out all the cases
              // when this would be undefined.
              src: step.image?.src as string,
              title: `Image Uploaded at ${step.timestamp}`,
              comments: step.comments,
            })) as ModuleImage[])
        : ([] as ModuleImage[]),
    [maybeSteps],
  );

  if (!auxComponentData) return <Loading />;

  return (
    <Layout>
      <AuxiliaryComponentDetails
        auxiliaryComponent={auxComponentData}
        updateComponent={update}
      />
      {maybeSteps && maybeSteps.length > 0 ? (
        <CommentView steps={maybeSteps} marginTop="8px" />
      ) : null}
      {imageList.length > 0 ? <ImageGrid images={imageList} /> : null}
    </Layout>
  );
}
